import { Table } from "flowbite-react";
import React, { useState, useEffect } from "react";
import axios from "axios";

function CPressingQuantity({ orderid,Sub_Order_id }) {
    const [completed_quantity, Setcompleted_quantity] = useState({});

    useEffect(() => {
        fetch_completed_quantity();
    }, []); 

    const fetch_completed_quantity = async () => {
        try {
            const response = await axios.get(`pressing/fetch_complete_quantity/${orderid}/${Sub_Order_id}`);
            const completedquantityData = response.data;
            Setcompleted_quantity(completedquantityData);
        } catch (error) {
            console.error("Error fetching completed_quantity data:", error);
        }
    };

    return (
        <>
            <div className="overflow-x-auto mt-4">
                <Table className="border">
                    <Table.Head className="border">
                        <Table.HeadCell className="border">Size</Table.HeadCell>
                        {completed_quantity.updated_marker && completed_quantity.updated_marker.length > 0 ? (
                            completed_quantity.updated_marker.map((item, index) => (
                                <Table.HeadCell key={index} className="border">{item.size}</Table.HeadCell>
                            ))
                        ) : (
                            <Table.HeadCell>No sizes available</Table.HeadCell>
                        )}
                        <Table.HeadCell>Total</Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className="border whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                {'Quantity'}
                            </Table.Cell>
                            {completed_quantity.updated_marker && completed_quantity.updated_marker.length > 0 ? (
                                completed_quantity.updated_marker.map((item, index) => (
                                    <Table.Cell key={index} className="border">{item.quantity}</Table.Cell>
                                ))
                            ) : (
                                <Table.Cell>No quantities available</Table.Cell>
                            )}
                            <Table.Cell className="border">{completed_quantity.total_quantity || 0}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </div>
        </>
    );
};

export default CPressingQuantity;
